<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('survey_detail')" icon="briefcase">
      <div>
        <a :href="urlGenerator('/staff-survey')" class="btn btn-success mr-2 mb-4">
          <app-icon class="size-20 mr-2" name="arrow-left"/>
          {{ $t('back_to_surveys') }}
        </a>
      </div>
    </app-page-top-section>

    <app-table
        id="survey-details-table"
        :options="options"
        :card-view="false"
        @reload="reloadSurveyTable"
        @getRows="getSelectedRows"
        @action="triggerActions"
    />

    <app-staff-survey-create-edit-modal
        v-if="isModalActive"
        v-model="isModalActive"
        :selected-url="selectedUrl"
        @close="isModalActive = false"
    />

    <app-confirmation-modal
        v-if="confirmationModalActive"
        icon="trash-2"
        modal-id="app-confirmation-modal"
        @confirmed="confirmed('survey-details-table')"
        @cancelled="cancelled"
    />


  </div>
</template>

<script>

import StaffSurveyDetailsMixin from "../../Mixins/StaffSurveyDetailsMixin";
import {GET_STAFF_SURVEYS} from "../../../Config/ApiUrl";
import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import AppFunction from "../../../../core/helpers/app/AppFunction";

export default {
  mixins: [StaffSurveyDetailsMixin, DatatableHelperMixin],
  props: {
    id: {
      type: String
    },
    survey: {
      type: Object,
      required: false, // Ensure the prop is required
    },
    visits: {
      type: Object,
      required: false, // Ensure the prop is required
    },
  },
  data() {
    return {
      isModalActive: false,
      selectedUrl: '',
      tickets: [],
      surveyId: '',
      currentSurvey: this.survey, // Pass the survey prop to data
    };
  },
  async created() {
    // this.options = {
    //   visits: this.visits, // Wrap the array in an object
    // };
    // this.initializeSurveyDetails(this.currentSurvey); // Pass to the mixin method
  },
  methods: {
    openModal() {
      this.isModalActive = true;
      this.selectedUrl = ''
    },
    urlGenerator(url) {
      return url.startsWith('http')
          ? url
          : `${AppFunction.getBaseUrl()}/${url.split('/').filter(d => d).join('/')}`;
    },
    triggerActions(row, action, active) {
      // if (action.title === this.$t('edit')) {
      //   this.selectedUrl = `${GET_STAFF_SURVEYS}/${row.id}/details`;
      //   this.isModalActive = true;
      // }
      // else {
      //   this.getAction(row, action, active)
      // }

    },
  },
};
</script>
